import timestampService from "../../service/timestampService";
import drawerStyles from "../../styles/drawer.module.css";

const VisitHoursListItem = ({
  hasSwatch = true,
  start,
  end,
  bgColor,
  borderColor,
  borderType,
  label,
}: {
  start: string;
  end: string;
  bgColor?: string;
  borderColor?: string;
  label: string;
  borderType?: "SOLID" | "DASHED" | "DOTTED";
  // Omit the colour swatch for text-only rows that are not drawn in the timeline
  hasSwatch?: boolean;
}) => {
  return (
    <div className={drawerStyles.visitHoursListItem}>
      <span className="flex items-center gap-2">
        {hasSwatch ? (
          <div
            style={{
              borderRadius: "5px",
              backgroundColor: bgColor,
              width: "16px",
              height: "16px",
              border: `1px ${borderType === "DASHED" ? "dashed" : borderType === "DOTTED" ? "dotted" : "solid"} ${borderColor}`,
            }}
          ></div>
        ) : (
          // Same footprint as a swatch, so the label lines up with the rows above
          <div style={{ width: "16px", height: "16px" }}></div>
        )}
        {label}
      </span>
      ({timestampService.getHoursAndMinutesTimestamp(start)} -{" "}
      {timestampService.getHoursAndMinutesTimestamp(end)})
    </div>
  );
};

export default VisitHoursListItem;
